import ATOMS_FILE_NAME from './ATOMS_FILE_NAME'

export default `${ATOMS_FILE_NAME}.text`
